import {apolloClient} from '@/graphql/apolloWrapper'
import {LICENSE_CREATE} from "@/graphql/mutations/licenses/create"
import {COMMAND_JOB_CREATE} from '@/graphql/mutations/jobs/create'
import {GET_ALL_LICENSES} from '@/graphql/queries/licenses/all'

const state = {
  licenses: []
};

const getters = {
  licensesAll: (state) => state.licenses,
  licenseById: (state) => (licenseId) => state.licenses.find(license => license.id === licenseId),
  licenseByStatus: (state) => (statusCode) => state.licenses.filter(license => license.status === statusCode)
};

const mutations = {
  PREPEND_NEW_LICENSE (state, license) {
    state.licenses.unshift(license);
  },
  UPDATE_LICENSE_LIST (state, licenses) {
    state.licenses = licenses;
  },

};

const actions = {
  async licenseCreate ({commit}, licenseForm) {
    const {data} = await apolloClient.mutate({mutation: LICENSE_CREATE, variables: {input: licenseForm}});
    if (data) {
      commit('PREPEND_NEW_LICENSE', data.licenseCreate);
    }
  },
  async licenseFetchList ({commit}) {
    const {data} = await apolloClient.query({query: GET_ALL_LICENSES});
    if (data && data.licenseList) {
      commit('UPDATE_LICENSE_LIST', data.licenseList);
    }
  },
  async licenseActivate ({dispatch, commit}, activationForm) {
    await apolloClient.mutate({
      mutation: COMMAND_JOB_CREATE,
      variables: {input: activationForm}
    }).then((response) => {
      dispatch('addInfoNotification', "License activation is now scheduled to be processed by the selected grab server.");
      dispatch('licenseFetchList');
      dispatch('serverFetchList');
    })
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/licenses.js